export default __webpack_public_path__ + "static/media/loader.cf8a7011.svg";